import { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './cars_v2/Header';
import Footer from './cars_v2/Footer';
import Home from './cars_v2/Home';
import Lots from './cars_v2/Lots';
import Service from './cars_v2/Service';
import Reserve from './cars_v2/Reserve';

export default function CarDealerTemplate() {
  const [page, setPage] = useState('home');
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [page]);
  return (
    <div className="min-h-screen bg-[#15141A]" data-testid="atl-template-root">
      <Header page={page} setPage={setPage} />
      <AnimatePresence mode="wait">
        <motion.main key={page} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.4 }} data-testid={`atl-page-${page}`}>
          {page === 'home' && <Home setPage={setPage} />}
          {page === 'lots' && <Lots setPage={setPage} />}
          {page === 'service' && <Service setPage={setPage} />}
          {page === 'reserve' && <Reserve setPage={setPage} />}
        </motion.main>
      </AnimatePresence>
      <Footer setPage={setPage} />
    </div>
  );
}
